import {
  Layout,
  ReferredPage,
} from '@packages/web-shared/components/referrals';
import { FirebaseProvider } from '@packages/web-shared';
import DescopeLogin from '@packages/web-shared/components/auth/DescopeLogin';
import DescopeSessionProvider from '@packages/web-shared/components/auth/DescopeSessionProvider';
import firebaseApp from './firebase';
import { ClinicalAppPermission } from '@packages/core-shared';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
} from 'react-router-dom';
import {
  AskForRightsPage,
  AuthProvider,
  PrivateElement,
} from '@percihealth/react-auth';
import HealixReferral from './components/pages/HealixReferral';
import { ScrollToTop } from '@percihealth/react';

export default function App() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <Layout>
            <ScrollToTop />
            <Outlet />
          </Layout>
        }
      >
        <Route
          path="/"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <HealixReferral />
            </PrivateElement>
          }
        />
        <Route
          path="referred"
          element={
            <PrivateElement permission={ClinicalAppPermission.CrmReferrer}>
              <ReferredPage />
            </PrivateElement>
          }
        />
        <Route path="/login" element={<DescopeLogin />} />
        <Route path="/ask-for-rights" element={<AskForRightsPage />} />
      </Route>,
    ),
  );

  // FirebaseProvider for the storage the document upload writes to.
  return (
    <DescopeSessionProvider firebaseApp={firebaseApp}>
      <AuthProvider firebaseApp={firebaseApp}>
        <FirebaseProvider firebaseApp={firebaseApp}>
          <RouterProvider router={router} fallbackElement={<p>Loading...</p>} />
        </FirebaseProvider>
      </AuthProvider>
    </DescopeSessionProvider>
  );
}
